import * as React from 'react';

const resetStyle: React.CSSProperties = {
  display: 'block',
  WebkitAppearance: 'none',
  background: 'none',
  border: 'none',
  padding: 0,
  font: 'inherit',
  color: 'inherit',
  cursor: 'pointer'
};

type Props = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'type'>;

export function ButtonBase({ style, children, ...props }: Props) {
  return (
    <button type="button" style={{ ...resetStyle, ...style }} {...props}>
      {children}
    </button>
  );
}
